import { BoxProps, TextNewProps } from '@jfs/ui-new'

export const styles = {
  headerTitle: {
    fontSize: 18,
    lineHeight: 24,
    fontFamily: 'jiotype-medium',
    color: 'BLACK_21',
    textAlign: 'left',
  } as TextNewProps,
  boxContainer: {
    ph: 40,
    pv: 16,
    height: '100%',
  } as BoxProps,
  rowContainer: {
    flexDirection: 'row',
  } as BoxProps,
}
